module.exports = __webpack_public_path__ + "img/bn.1d4e6091.svg";